import {Controller} from '@hotwired/stimulus';

/**
 * Marque comme sélectionnée (classe `selected`) la vignette `.box-wrapper` de chaque case cochée,
 * à la connexion (cases restaurées par le navigateur au rechargement) puis à chaque changement.
 *
 *   <ul class="boxes" {{ stimulus_controller('box-selection') }}>
 *     <li><div class="box-wrapper box-wrapper-input">
 *       <input type="checkbox" {{ stimulus_target('box-selection', 'checkbox') }}
 *              {{ stimulus_action('box-selection', 'sync', 'change') }}> …
 */
export default class extends Controller {
  static targets = ['checkbox'];

  checkboxTargetConnected(checkbox) {
    this.#mark(checkbox);
  }

  sync({currentTarget}) {
    this.#mark(currentTarget);
  }

  #mark(checkbox) {
    checkbox.closest('.box-wrapper').classList.toggle('selected', checkbox.checked);
  }
}
